import Text, { TextType } from "components/Text";

import { getExpirationInfo } from "components/ExpirationContent";
import { TextAndShapesPalette } from "lib/styles/colors";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const ICON_ONLY_IF_GOOD = false;

interface OwnProps {
  expDate?: Date | null;
}
export default function ExpirationRow(props: OwnProps): JSX.Element {
  const { icon, formattedText, color } = getExpirationInfo(
    props.expDate,
    ICON_ONLY_IF_GOOD
  );

  return (
    <Container>
      {icon && icon}
      <Text
        fontColor={color || TextAndShapesPalette.INPUT}
        style={{ marginLeft: "4px" }}
        type={TextType.PARAGRAPH}
      >
        {formattedText}
      </Text>
    </Container>
  );
}
